import React from "react";
import { Box, MenuItem, TextField, Typography } from "@mui/material";

export const LOCATION_CONTENT_LANGUAGES = [
  { code: "en", name: "English", label: "English — default/fallback" },
  { code: "hn", name: "Hinglish", label: "Hinglish" },
  { code: "hi", name: "Hindi", label: "Hindi" },
  { code: "bn", name: "Bengali", label: "Bengali" },
  { code: "gu", name: "Gujarati", label: "Gujarati" },
  { code: "kn", name: "Kannada", label: "Kannada" },
  { code: "mr", name: "Marathi", label: "Marathi" },
  { code: "ta", name: "Tamil", label: "Tamil" },
  { code: "te", name: "Telugu", label: "Telugu" },
];

export const getLocationContentByLanguage = (item = {}) => Object.fromEntries(
  LOCATION_CONTENT_LANGUAGES.map(({ code }) => {
    const value = code === "en" ? item : item.pageContentTranslations?.[code] || {};
    return [code, { content: value.content || "", metaTitle: value.metaTitle || "", metaDescription: value.metaDescription || "" }];
  })
);

export const hasUsableLocationContent = (value = "") => value
  .replace(/<[^>]*>/g, "")
  .replace(/&nbsp;|\s/g, "")
  .length > 0;

export const switchLocationContentLanguage = ({ language = "en", nextLanguage = "en", storedContent = {}, content = "", metaTitle = "", metaDescription = "", onLanguageChange = () => {}, confirmDiscard = () => true } = {}) => {
  const saved = storedContent[language] || {};
  if ((content !== (saved.content || "") || metaTitle !== (saved.metaTitle || "") || metaDescription !== (saved.metaDescription || "")) && !confirmDiscard()) return false;
  onLanguageChange(nextLanguage, storedContent[nextLanguage] || {});
  return true;
};

export const getLocationContentRequestPayload = ({ jobLocationContentId = "", language = "en", content = "", metaTitle = "", metaDescription = "", useAdminMeta = true, englishPayload = {} } = {}) => (
  language === "en" ? { ...englishPayload, useAdminMeta } : { jobLocationContentId, pageContentLanguage: language, content, metaTitle, metaDescription, useAdminMeta }
);

const JobLocationContentLanguageEditor = ({ language = "en", storedContent = {}, content = "", metaTitle = "", metaDescription = "", onLanguageChange = () => {} }) => {
  const handleChange = (event) => switchLocationContentLanguage({
    language,
    nextLanguage: event.target.value,
    storedContent,
    content,
    metaTitle,
    metaDescription,
    onLanguageChange,
    confirmDiscard: () => window.confirm("Discard unsaved SEO changes?"),
  });

  return <>
    <Box sx={{ mb: 2 }}>
      <TextField select fullWidth size="small" label="Page content language" value={language} onChange={handleChange}>
        {LOCATION_CONTENT_LANGUAGES.map(({ code, label }) => <MenuItem key={code} value={code}>{label}</MenuItem>)}
      </TextField>
    </Box>
    {language !== "en" && !hasUsableLocationContent(content) ? <Box sx={{ mb: 2 }}><Typography variant="caption" color="text.secondary">Translation missing; English will be displayed as fallback.</Typography></Box> : null}
  </>;
};

export default JobLocationContentLanguageEditor;
